module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage"
  }, [_c('a', {
    attrs: {
      "id": "title11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_vm._v("I hate the place. I hate the people."), _c('br'), _vm._v(" I hate the bloody niggers."), _c('br'), _vm._v(" Mustn’t call ’em that, you know.")])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—GRAHAM GREENE")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_vm._v("Nothing fuels a good flirtation"), _c('br'), _vm._v(" Like need and anger and desperation.")])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—AIMEE MANN")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_vm._v("I keep a close watch on this heart of mine,"), _c('br'), _vm._v(" I keep my eyes wide open all the time.")])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—JOHNNY CASH")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f9934f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429998314_epi01.vue
// module id = 66
// module chunks = 0